// frontend/modules/auth/context/AuthContext.tsx
import React, { createContext, useContext } from 'react';
import { useAuthStore } from '../stores/auth-store';
import { AuthUser } from "@/shared/api/model";

const AuthContext = createContext<AuthUser | null>(null);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user } = useAuthStore();
    return <AuthContext.Provider value={user}>{children}</AuthContext.Provider>;
};

export const useAuthUser = () => {
    const context = useContext(AuthContext);
    if (context === null) {
        throw new Error('useAuthUser must be used within an AuthProvider');
    }
    return context;
};